import React from 'react'
import { css } from 'styled-components'
import { Grid as GridBase, styled } from '@mui/material'
import { Dialog as DialogBase } from '@chilecompra/react-kit/components'

export const Dialog = styled(DialogBase)`
  // FIXME: it has to be like this until the Dialog component has a cleaner way to set the backdrop
  // background color.
  background-color: transparent;

  &:focus-visible {
    outline: 0;
  }
`

export const GridContainer = styled(({ enableBorder, ...props }) => <GridBase container {...props} />)`
  &.MuiGrid-container {
    ${props =>
      !props.enableBorder
        ? ''
        : css`
            border: 1px solid ${props => props.theme.palette.brand.gray1};
            border-radius: 4px;
          `}
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const GridItem = styled(props => <GridBase item {...props} />)`
  &.MuiGrid-item {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const Title = styled('h2')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 22px;
  margin: 0;
`

export const Subtitle = styled('h3')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 18px;
  font-weight: normal;
  letter-spacing: 0;
  line-height: 22px;
  margin: 0;
`

export const BodyParagraph = styled('p')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 13px;
  letter-spacing: 0;
  line-height: 18px;
  margin: 0;
`

export const BodySecondText = styled('span')`
  color: ${props => props.theme.palette.brand.black3};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 12px;
  letter-spacing: 0;
  line-height: 16px;
`

export const BodyLink = styled('a')`
  color: ${props => props.theme.palette.brand.primary};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 13px;
  letter-spacing: 0;
  line-height: 16px;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`
